import React from 'react'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import Typography from '../../../components/common/Typography'
import { intlDateWithTimeFormat } from '../../../utils/dateUtils'

export default function Item({ event = {} }) {
  const description = typeof event.description === 'string' ? event.description : ''
  const words = description.trim().split(/\s+/).filter(Boolean)
  const firstTwo = words.slice(0, 2).join(' ')
  const rest = words.slice(2).join(' ')

  return (
    <TableRow hover>
      <TableCell align="left" sx={{ pr: 3 }}>
        <Typography fontFamily="lexend">
          {intlDateWithTimeFormat(event.createdAt)}
        </Typography>
      </TableCell>

      <TableCell align="left">
        <Typography fontFamily="lexend">
          <Typography component="span" color="primary" fontFamily="lexend">
            {firstTwo}
          </Typography>
          {rest && ` ${rest}`}
        </Typography>
      </TableCell>
    </TableRow>
  )
}